module.exports = __webpack_public_path__ + "static/media/claims_portal.804b7da2.svg";